module.exports = __webpack_public_path__ + "static/media/addressIcon.ae05f370.svg";